"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clsx_1 = __importDefault(require("clsx"));
var i18next_1 = __importDefault(require("i18next"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var regexValidator_1 = require("@/react-app/common/services/regexValidator");
var Button_1 = __importDefault(require("@/react-app/common/components/Button"));
var Tooltip_1 = require("@/react-app/common/components/Tooltip");
var ImportPhashImagesItemModal_1 = __importDefault(require("../ImportPhashImagesItemModal"));
var notifier_1 = __importDefault(require("@/react-app/common/utils/notifier"));
function DictionaryItemsEditor(_a) {
    var items = _a.items, setItems = _a.setItems;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = __read((0, react_1.useState)(''), 2), newItem = _b[0], setNewItem = _b[1];
    var _c = __read((0, react_1.useState)(''), 2), newItemError = _c[0], setNewItemError = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isImportModalOpen = _d[0], setIsImportModalOpen = _d[1];
    var getValidationError = function (item) {
        if (!item) {
            return i18next_1.default.t('AUTOMATION.IMAGES_LISTS.ERROR.CANNOT_EMPTY');
        }
        var existingItem = items.find(function (i) { return i.entry === item; });
        if (existingItem) {
            return i18next_1.default.t('AUTOMATION.IMAGES_LISTS.ERROR.ALREADY_EXIST');
        }
        var lowerCaseItem = item.toLowerCase();
        var existsInsensitive = items.some(function (element) { return element.entry.toLowerCase() === lowerCaseItem; });
        if (existsInsensitive) {
            return i18next_1.default.t('AUTOMATION.IMAGES_LISTS.ERROR.EXIST_CASE_SENSITIVE');
        }
        var phashRegex = /^[0-9A-Fa-f]+$/;
        if (!phashRegex.test(item)) {
            return i18next_1.default.t('AUTOMATION.IMAGES_LISTS.ERROR.INVALID_PHASH');
        }
        return 0;
    };
    var deleteItem = function (item) {
        var newItems = items.filter(function (i) { return i.entry !== item; });
        setItems(newItems);
    };
    var handleInputKeyDown = function (e) {
        if (e.key === 'Enter') {
            addItem();
        }
    };
    var addItem = function () {
        var error = getValidationError(newItem);
        if (error) {
            setNewItemError(error);
            return;
        }
        setNewItemError('');
        setItems(__spreadArray(__spreadArray([], __read(items), false), [{ entry: newItem }], false));
        setNewItem('');
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, clsx_1.default)('add-phash-item', { 'has-error': newItemError }) },
            react_1.default.createElement("label", { className: "control-label", htmlFor: "expression" },
                t('AUTOMATION.IMAGES_LISTS.LIST_BUILDER.ADD_ITEM_LABEL'),
                react_1.default.createElement("span", { className: "tooltip-icon more-info-tooltip implioicons-question-mark-filled eva-tooltip-container m" },
                    react_1.default.createElement(Tooltip_1.Tooltip, { className: "custom-add-phash-tooltip" }, t('AUTOMATION.IMAGES_LISTS.LIST_BUILDER.ADD_ITEM_ICON_TOOLTIP')))),
            react_1.default.createElement("table", { className: "table table-striped", "data-ng-if": "vm.dictionary.items.length > 0" },
                react_1.default.createElement("tbody", null, items.sort().map(function (item, index) { return (react_1.default.createElement("tr", { key: index },
                    react_1.default.createElement("td", { className: (0, clsx_1.default)('col-md-11', { 'regex-item': (0, regexValidator_1.isRegExp)(item.entry) }) },
                        react_1.default.createElement("span", null, item.entry)),
                    react_1.default.createElement("td", { className: "col-md-1" },
                        react_1.default.createElement("a", { className: "delete-icon pull-right", onClick: function () { return deleteItem(item.entry); }, title: t('AUTOMATION.IMAGES_LISTS.LIST_BUILDER.REMOVE_TOOLTIP') })))); }))),
            react_1.default.createElement("div", { className: (0, clsx_1.default)('form-group', { 'has-error': newItemError.length > 0 }) },
                react_1.default.createElement("div", { className: "dictionary-item-editor__input-button-group add-container" },
                    react_1.default.createElement("input", { type: "text", id: "expression", value: newItem, onChange: function (e) { return setNewItem(e.target.value); }, onKeyDown: handleInputKeyDown, className: (0, clsx_1.default)('form-control add-word', { 'regex-item': (0, regexValidator_1.isRegExp)(newItem) }), 
                        // eslint-disable-next-line jsx-a11y/no-autofocus
                        autoFocus: true }),
                    react_1.default.createElement(Button_1.default, { className: "add-button", onClick: addItem, text: t('AUTOMATION.IMAGES_LISTS.BTN.ADD') })),
                react_1.default.createElement("p", { className: "help-block" }, newItemError))),
        react_1.default.createElement("div", { className: "row button-row" },
            react_1.default.createElement("div", { className: "col-sm-12" },
                react_1.default.createElement(Button_1.default, { onClick: function () { return setIsImportModalOpen(true); }, text: t('AUTOMATION.IMAGES_LISTS.BTN.IMPORT') }))),
        react_1.default.createElement(ImportPhashImagesItemModal_1.default, { isOpen: isImportModalOpen, setIsOpen: setIsImportModalOpen, onConfirm: function (importedItems) {
                // new items without duplications
                var newItemsWithoutDuplicates = importedItems.filter(function (item) { return !items.some(function (i) { return i.entry === item; }); });
                var newItemsWithComments = newItemsWithoutDuplicates.map(function (item) { return ({ entry: item }); });
                var numberOfAddedItems = newItemsWithComments.length;
                if (numberOfAddedItems > 0) {
                    if (numberOfAddedItems === 1) {
                        notifier_1.default.success(t('AUTOMATION.IMAGES_LISTS.LIST_BUILDER.ITEM_IMPORTED_TEXT_REACT'));
                    }
                    else {
                        notifier_1.default.success(t('AUTOMATION.IMAGES_LISTS.LIST_BUILDER.ITEM_IMPORTED_TEXT_REACT_PLURAL', { numberOfAddedItems: numberOfAddedItems }));
                    }
                }
                setItems(__spreadArray(__spreadArray([], __read(items), false), __read(newItemsWithComments), false));
            } })));
}
exports.default = DictionaryItemsEditor;
